<template>
  <div>
    <div
      class="padding-x-16 padding-y-8 border-radius-8 border--solid border--complementary-50"
    >
      <div class="flex-between">
        <span
          class="color-complementary-300 font-size-12 padding-left-30 text-justify"
        >
          {{ item.caption }}
        </span>
        <span class="flex-center">
          <div
            v-if="item.registerCondition"
            class="conditions-button margin-left-4 color-primary border--solid border--primary-100 border-radius-8 width-28 height-28 flex-center cursor--pointer"
            v-b-tooltip.hover
            :title="$lang.guidance_and_register_conditions"
            @click="handleOpenRegisterConditionsModal()"
          >
            <mdicon name="help-circle-outline" size="20" class="flex" />
          </div>
          <div
            v-if="counter"
            class="flex-center width-140 font-size-12 color-complementary-100 border--solid border--complementary-50 border-radius-8 padding-x-8 padding-y-2 cursor--not-allowed"
          >
            <div class="direction--ltr margin-left-4 width--max-content">
              {{ counter }}
            </div>
            <span class="width--max-content">{{ $lang.toStart }}</span>
          </div>
          <Button
            v-else
            size="sm"
            contentClass="justify-content-center"
            variant="outline-primary"
            :text="$lang.start"
            @click="goToRegister(item)"
          />
        </span>
      </div>
    </div>
    <Modal
      :show="isRegisterConditionsModal"
      :title="titleRegisterConditionsModal"
      :hasClose="true"
      :hasFooter="false"
      @close="handleCloseRegisterConditionsModal"
    >
      <template #body>
        <div v-html="bodyRegisterConditionsModal"></div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { Modal } from "@/components/re-design";
import { Button } from "@/components/re-design/forms";
import { onBeforeUnmount, ref, toRefs } from "vue";
import { pathOr } from "ramda";
import { goToRoute } from "@/shared/utils";
export default {
  components: { Modal, Button },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },

  setup(props) {
    // bind props
    const { item } = toRefs(props);

    const isRegisterConditionsModal = ref(false);
    const titleRegisterConditionsModal = ref(null);
    const bodyRegisterConditionsModal = ref(null);
    const handleCloseRegisterConditionsModal = () => {
      isRegisterConditionsModal.value = false;
    };
    const handleOpenRegisterConditionsModal = () => {
      const { caption, registerCondition } = item.value;
      titleRegisterConditionsModal.value = caption;
      bodyRegisterConditionsModal.value = registerCondition;
      isRegisterConditionsModal.value = true;
    };

    const goToRegister = () => {
      const code = pathOr(null, ["code"], item.value);
      goToRoute("detail-registrations", { code }, {}, false);
    };

    const timerQueue = ref(null);
    const counter = ref(null);
    const reset = () => {
      counter.value = null;
      clearInterval(timerQueue.value);
    };
    const timer = () => {
      const { gregorianStartDate } = item.value;
      const startedTime = new Date(gregorianStartDate).getTime();

      const nowTime = new Date().getTime();
      const differentTimeSeconds = Math.round((startedTime - nowTime) / 1000);
      if (differentTimeSeconds <= 0) {
        reset();
        return;
      }

      let distance = differentTimeSeconds;
      clearInterval(timerQueue.value);
      timerQueue.value = setInterval(() => {
        distance -= 1;

        let days = Math.floor(distance / (3600 * 24));
        let hours = Math.floor((distance % (3600 * 24)) / 3600);
        let minutes = Math.floor((distance % 3600) / 60);
        let seconds = Math.floor(distance % 60);
        days = days ? `${days}:` : "";
        hours = hours < 10 ? `0${hours}:` : `${hours}:`;
        minutes = minutes < 10 ? `0${minutes}:` : `${minutes}:`;
        seconds = seconds < 10 ? `0${seconds}` : seconds;

        counter.value = `${days}${hours}${minutes}${seconds}`;

        if (distance <= 0) {
          reset();
        }
      }, 1000);
    };
    timer();

    onBeforeUnmount(() => reset());

    // return data to be used in template
    return {
      isRegisterConditionsModal,
      titleRegisterConditionsModal,
      bodyRegisterConditionsModal,
      handleCloseRegisterConditionsModal,
      handleOpenRegisterConditionsModal,
      goToRegister,
      counter,
    };
  },
};
</script>
<style lang="scss" scoped>
.conditions-button {
  &:hover {
    background-color: #e0f0ff;
  }
}
</style>
